import * as actions from './actions';

export const INITIAL_STATE = {
    permissions: null,
    permissionsFetching: false,
    permissionsError: null
};

export default (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case actions.GET_USER_PERMISSIONS_REQUEST:
            return {
                ...state,
                permissionsFetching: true,
                permissionsError: INITIAL_STATE.permissionsError
            };
        case actions.GET_USER_PERMISSIONS_SUCCESS:
            return {
                ...state,
                permissions: action.response,
                permissionsFetching: INITIAL_STATE.permissionsFetching,
                permissionsError: INITIAL_STATE.permissionsError
            };
        case actions.GET_USER_PERMISSIONS_ERROR:
            return {
                ...state,
                permissions: INITIAL_STATE.permissions,
                permissionsFetching: INITIAL_STATE.permissionsFetching,
                permissionsError: action.message
            };
        default:
            return state;
    }
};
